import { defineEnvironment } from './common';
import { IPermissions } from 'src/app/models/user-profile.model';

export const environment = defineEnvironment({
	production: false,
	type: 'test',
	baseUrl: 'https://milktracker.testing.angeleyehealth.com',
	apiUrl: 'https://milktracker-api.testing.angeleyehealth.com/api/v1',
	authAppBaseUrl: 'https://auth.testing.angeleyehealth.com',
	portalUrl: 'https://milktracker-api.testing.angeleyehealth.com/portal',
	settings: {
		authGuard: false,
		sessionLengthMinutes: 20,
		timeoutDuration: 15000,
		enableBadgeScanning: true,
		enableSelectMilk: true,
		bypassExpiration: true,
		showMobileDateTimePicker: false,
		bypassOrderMatching: false, // Set to true for testing manual entry
		apiDelay: 0,
		removeAllOrders: false,
		clerkSignInURL:
			'https://auth.testing.angeleyehealth.com/milktracker/sign-in',
		clerkSignOutURL:
			'https://auth.testing.angeleyehealth.com/milktracker/sign-out',
		// You can comment this whole thing out if you want to use the default permissions
		overridePermissions: {} as unknown as IPermissions,
		overrideFeatureFlags: {},
		kioskSessionLengthInMinutes: 1,
	},
});

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
